<template>
  <md-dialog
    v-if="this.isOpenCreditCardDialog" :md-active.sync="this.isOpenCreditCardDialog"
    class="modalEdit__instructors dialog-cart"
    @md-opened="onDialogOpened"
    @md-closed="onDialogClosed"
  >

    <div class="w-100 position-fixed mobile-cancel">
      <span
        class="material-icons close text-right"
        @click="closeDialog"
      >close</span
      >
    </div>
    <div class="body-modal-instructor modal-body">
      <div class="md-dialog-title text-left">
        <h3 class="text-bold">{{ `${cardForm.id ? 'ACTUALIZAR TARJETA' : 'AGREGAR UNA NUEVA TARJETA'}` }} </h3>
        <h4 class="text-bold mb-3">
          Complete los detalles de su tarjeta de crédito a continuación.
        </h4>
      </div>
      <div class="form-instructor dialog-body" style="text-align: start">
        <div class="row justify-content-between mx-0 mobile-dialog-PM">
          <div class="col-md-12 col-lg-8 row px-0">
            <div class="col-md-12 pr-0 mb-2">
              <div class="form-group">
                <label>
                  Número de tarjeta:
                </label>
                <div>
                  <div
                    id="card-number"
                    class="form-control"
                    style="padding-top: 15px"
                  ></div>
                </div>
              </div>
            </div>
            <div class="col-md-6 pr-0 mb-2">
              <div class="form-group">
                <label>
                  Expiración (Mes/Año):
                </label>
                <div>
                  <div
                    id="card-expiry"
                    class="form-control"
                    style="padding-top: 15px"
                  ></div>
                </div>
              </div>
            </div>
            <div class="col-md-6 pr-0 mb-2">
              <div class="form-group">
                <label>
                  CVC:
                </label>
                <div>
                  <div
                    id="card-cvc"
                    class="form-control"
                    style="padding-top: 15px"
                  ></div>
                </div>
              </div>
            </div>

          </div>

          <div class="col-md-12 col-lg-4">
            <div class="cardPayment card-payment-center px-4 py-2 pt-2">
              <span>Aceptamos:</span>
              <div class="card-methods-pay col-md-12">
                <img
                  src="@/assets/images/paypal/paypal.svg"
                  alt=""
                  class="paypal-svg-icon method-paypal-top"
                />
              </div>
              <div class="all-card-methods-pay row">
                <div class="col-3 p-lg-1 pt-lg-4">
                  <img
                    src="@/assets/images/paypal/visa.svg"
                    alt=""
                    class="paypal-svg-icon"
                  />
                </div>
                <div class="col-3 p-lg-1 pt-lg-4">
                  <img
                    src="@/assets/images/paypal/mastercard.svg"
                    alt=""
                    class="paypal-svg-icon"
                  />
                </div>
                <div class="col-3 p-lg-1 pt-lg-4">
                  <img
                    src="@/assets/images/paypal/maestro.svg"
                    alt=""
                    class="paypal-svg-icon"
                  />
                </div>
                <div class="col-3 p-lg-1 pt-lg-4">
                  <img
                    src="@/assets/images/paypal/americanexpress.svg"
                    alt=""
                    class="aexpress-svg-icon"
                  />
                </div>
              </div>
              <!-- <img
                :src="require(`@/assets/images/logo/safe-checkout.png`)"
                alt="icon visa"
                class="pb-1"
              /> -->
            </div>
          </div>
        </div>
      </div>
      <md-dialog-actions class="modal-footer">
        <base-button
          class="md-primary w-auto"
          type="secondary"
          @click="closeDialog"
        >CANCELAR
        </base-button>
        <base-button
          :loading="isLoading"
          class="md-primary w-auto"
          type="primary"
          @click="createToken"
        >{{ `${cardForm.id ? 'ACTUALIZAR TARJETA' : 'AGREGAR TARJETA'}` }}
        </base-button>
      </md-dialog-actions>
    </div>
  </md-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseButton from '../../../../../components/BaseButton';
import axios from 'axios';
import { DEFAULT_CARD_FORM_VALUES } from '@/util/constants';
import { CLOSE_CREDIT_CARD_DIALOG } from '@/store/actions/card';
import config from '@/config/config';

export default {
  name: 'CreateCreditCardDialog',
  components: {
    BaseButton,
  },
  emits: ['success'],

  data () {
    return {
      vm: this,
      isLoading: false,
      stripe: {
        token: null,
        cardNumber: null,
        cardExpiry: null,
        cardCvc: null,
      },
    };
  },
  computed: {
    ...mapGetters([
      'getAllCountries',
      'isOpenCreditCardDialog',
      'getSelectedCreditCard',
    ]),
    stripeElements () {
      return this.$stripe.elements();
    },
  },
  watch: {
    getSelectedCreditCard: function(newValue) {
      this.cardForm = newValue ? newValue : DEFAULT_CARD_FORM_VALUES;
    },
    isOpenCreditCardDialog: function(newValue) {
      if (newValue) {

        this.$nextTick(() => {
          // ESTE CÓDIGO SE EJECUTA DESPUÉS de que el modal ha sido insertado
          // o se ha cambiado su visibilidad y está listo en el DOM.

          console.log('Modal abierto y DOM actualizado con nextTick.', document.getElementById('card-number'));

          this.createStripeElements();
        });

      }
    },
  },

  mounted () {
    console.log('mounted', this.isOpenCreditCardDialog);
  },

  methods: {
    createStripeElements () {
      const style = {
        base: {
          color: 'black',
          fontFamily: '\'Barlow\', sans-serif',
          fontSize: '16px',
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a',
        },
      };

      this.stripe.cardNumber = this.stripeElements.create('cardNumber', { style });
      this.stripe.cardNumber.mount('#card-number');

      this.stripe.cardExpiry = this.stripeElements.create('cardExpiry', { style });
      this.stripe.cardExpiry.mount('#card-expiry');

      this.stripe.cardCvc = this.stripeElements.create('cardCvc', { style });
      this.stripe.cardCvc.mount('#card-cvc');
    },
    onDialogOpened () {
      console.log('DialogOpened');
      this.createStripeElements();
    },
    onDialogClosed () {
      console.log('onDialogClosed');

      this.resetStripe();
    },
    async stripeCustomer () {
      const response = await axios.post(`${config.data.apiUrl}/stripe/customer`, {}, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('user-token'), // the token is a variable which holds the token
        },
      });

      return response.data;
    },
    async createStripeCard (customer, source) {
      const response = await axios.post(`${config.data.apiUrl}/stripe/card/create`, {
        customer, source,
      }, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('user-token'), // the token is a variable which holds the token
        },
      });

      return response.data;
    },
    async updateStripeCard (customer, source) {
      const response = await axios.post(`${config.data.apiUrl}/stripe/card/update/${this.cardForm.id}`, {
        customer, source,
      }, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('user-token'), // the token is a variable which holds the token
        },
      });

      return response.data;
    },
    async createToken () {
      this.isLoading = true;
      const customer = await this.stripeCustomer();

      const { token, error } = await this.$stripe.createToken(this.stripe.cardNumber);
      if (error) {
        this.notify('danger', error.message);
        this.isLoading = false;
        return null;
      }

      const creditCardId = this.cardForm.id;

      try {
        if (creditCardId) {
          await this.updateStripeCard(customer.id, token.id);
        } else {
          await this.createStripeCard(customer.id, token.id);
        }
      } catch (e) {

        this.isLoading = false;
        return this.notify('danger', `Tenemos problemas para ${creditCardId ? 'actualizar' : 'agregar'} la tarjeta`);
      }

      this.closeDialog();
      this.notify(
        'success',
        'Tarjeta de credito fue actualizada correctamente',
      );
      this.isLoading = false;
      this.$emit('success');
    },
    notify (type, message) {
      this.$notify({
        type: type,
        verticalAlign: 'top',
        horizontalAlign: 'right',
        message: message,
      });
    },
    resetStripe () {
      this.stripe.cardNumber.destroy();
      this.stripe.cardExpiry.destroy();
      this.stripe.cardCvc.destroy();

      this.stripe.cardNumber = null;
      this.stripe.cardExpiry = null;
      this.stripe.cardCvc = null;
    },
    closeDialog () {
      this.resetStripe();
      this.isLoading = false;
      this.$store.dispatch(CLOSE_CREDIT_CARD_DIALOG);
    },
  },
};
</script>

<style>
.multiselect__option--highlight {
  background: #000000 !important;
  outline: none;
  color: #fff !important;
}

.cardPayment {
  margin-top: 0px !important;
  background-color: #fff;
  width: 100%;
}

.card-payment-center {
  margin: 0px;
}

.multiselect--above.multiselect--active .multiselect__current,
.multiselect--above.multiselect--active .multiselect__input,
.multiselect--above.multiselect--active .multiselect__tags {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.multiselect__select {
  -webkit-transition: none;
  transition: none;
  width: 50px !important;
  margin-top: 0;
  padding: 10px;
  height: 52px;
}

.card-methods-pay {
  border-radius: 1px solid #000;
  padding: 10px;
}

.paypal-svg-icon {
  width: 100px;
  height: 50px !important;
}

.aexpress-svg-icon {
  width: 50px;
  height: 50px !important;
}

.method-paypal-top {
  margin-top: 20px;
  position: absolute;
  top: -20px;
  padding: 5px;
  background-color: #ffffff;
}

.all-card-methods-pay {
  padding: 30px 10px;
  border-radius: 10px;
  border: 1px solid #989898;
  align-content: center;
}

@media (max-width: 600px) {
  .paypal-svg-icon {
    width: 90px;
    height: 40px !important;
    padding-bottom: 5px;
  }

  .aexpress-svg-icon {
    width: 40px;
    height: 40px !important;
  }

  .all-card-methods-pay {
    height: 70px;
    align-content: center;
    padding: 0px;
  }
}

@media (min-width: 900px) and (max-width: 1440px) {
  .aexpress-svg-icon {
    width: 50px !important;
    height: 35px !important;
  }
}

.multiselect {
  outline: none;
  border: 0px;
  border-radius: 5px;
}

.multiselect--active .multiselect__select {
  -webkit-transform: none;
  transform: none;
}

.form-control::after {
  font-size: 1rem !important;
  color: black !important;
}

.valid-feedback {
  margin-top: 0px !important;
}
</style>
